import React from "react";
import "./App.css";
import Home from "./Pages/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SearchPage from "./Pages/SearchPage";


function App() {
  
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route
            path="/search"
            element={
              <>
                {" "}
                <SearchPage />{" "}
              </>
            }
          />

          <Route
            path="/"
            element={
              <>
                <Home />{" "}
              </>
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
